// extracted by mini-css-extract-plugin
module.exports = {"checkboxesContainer":"CreateEditClinics_checkboxesContainer__2rBT_","emails":"CreateEditClinics_emails__11MTp","emailTagLabel":"CreateEditClinics_emailTagLabel__3XOUO"};